
import { UserRole } from "@/hooks/useUserRoles";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";

interface UserWithRoles {
  id: string;
  email: string;
  roles: UserRole[];
}

interface UserRoleItemProps {
  user: UserWithRoles;
  onAddRole: (user: UserWithRoles) => void;
  onRemoveRole: (userId: string, role: UserRole) => void;
  isCurrentUser: boolean;
}

const UserRoleItem = ({ user, onAddRole, onRemoveRole, isCurrentUser }: UserRoleItemProps) => {
  const translateRoleName = (role: UserRole): string => {
    switch(role) {
      case "admin": return "Administrador";
      case "marketing": return "Marketing";
      case "support": return "Suporte";
      case "integrations_manager": return "Gerente de Integrações";
      default: return role;
    }
  };
  
  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-2">
        <div>
          <div className="flex items-center gap-2">
            <p className="font-medium">{user.email}</p>
            {isCurrentUser && (
              <Badge variant="outline" className="text-xs border-green-500 text-green-600">
                <Shield className="w-3 h-3 mr-1" />
                Você
              </Badge>
            )}
          </div>
          <p className="text-sm text-muted-foreground">{user.id}</p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onAddRole(user)}
        >
          Adicionar Função
        </Button>
      </div>
      <div className="flex flex-wrap gap-2 mt-2">
        {user.roles.map(role => (
          <Badge key={role} className="flex items-center gap-1">
            {translateRoleName(role)}
            <Button
              variant="ghost"
              size="icon"
              className="h-4 w-4 rounded-full"
              onClick={() => onRemoveRole(user.id, role)}
            >
              <span className="sr-only">Remover</span>
              &times;
            </Button>
          </Badge>
        ))}
        {user.roles.length === 0 && (
          <span className="text-sm text-muted-foreground">Nenhuma função atribuída</span>
        )}
      </div>
    </div>
  );
};

export default UserRoleItem;
